import { render, staticRenderFns } from "./SubscriptionRenewals.vue?vue&type=template&id=0d7b2d23&"
import script from "./SubscriptionRenewals.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRenewals.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionRenewals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d7b2d23')) {
      api.createRecord('0d7b2d23', component.options)
    } else {
      api.reload('0d7b2d23', component.options)
    }
    module.hot.accept("./SubscriptionRenewals.vue?vue&type=template&id=0d7b2d23&", function () {
      api.rerender('0d7b2d23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SubscriptionRenewals.vue"
export default component.exports